import { Record } from 'immutable';

export default class ResourceFortnoxSettingRecord extends Record({
  id: undefined,
  staffingCompany: undefined,
  fortnoxId: undefined,
}) {
}
